// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1TizA","icon":"style_icon__dTgNw"};